module.exports = __webpack_public_path__ + "files/SPIADI2026 - SPY4 - Guide Technique.61d626e41824755746c80295f488f149.pdf";